// extracted by mini-css-extract-plugin
export default {"song_play":"map_song_play__p4t5P"};